const _ = import.meta.env;
export const env = { ...import.meta.env, ...window['env'] };
